const masks = {
  50: { mask: "50", label: "50 - SOLICITUDES POR USUARIO" },
  51: { mask: "51", label: "51 - PAIS" },
  52: { mask: "52", label: "52 - PROVINCIA" },
  53: { mask: "53", label: "53 - MUNICIPIO" },
  54: { mask: "54", label: "54 - SECTOR" },
};
export default masks;
